const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div
  class="demo-container o-rhythm"
  style="max-width: 40rem; margin: 0 auto; padding: 0 1.25rem"
>
  <p>Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec id elit non mi porta gravida at eget metus. Vestibulum id ligula porta felis euismod semper.</p>
  `);
                if (this.isIn((context.has(`alignment`) ? context.get(`alignment`) : null), new Map([[0, `alignleft`], [1, `aligncenter`], [2, `alignright`]]))) {
                    this.echo(`    <div class="wp-block-image `);
                    this.echo(this.env.getFilter('escape').traceableCallable(7, this.source)(...[this.env, (context.has(`style`) ? context.get(`style`) : null), `html`, null, true]));
                    this.echo(`">
  `);
                }
                this.echo(`    <figure class="
      `);
                if (this.isIn((context.has(`alignment`) ? context.get(`alignment`) : null), new Map([[0, `alignfull`], [1, `alignwide`], [2, ``]]))) {
                    this.echo(`wp-block-image `);
                    this.echo(this.env.getFilter('escape').traceableCallable(10, this.source)(...[this.env, (context.has(`style`) ? context.get(`style`) : null), `html`, null, true]));
                }
                this.echo(`      size-large `);
                this.echo(this.env.getFilter('escape').traceableCallable(11, this.source)(...[this.env, (context.has(`alignment`) ? context.get(`alignment`) : null), `html`, null, true]));
                this.echo(`
      ">
      <img
        src="/media/MtBlanc1.jpg"
        alt="Mont Blanc"
        class="wp-image-130"
        srcset="
          /media/MtBlanc1.jpg         500w,
          /media/MtBlanc1-300x225.jpg 300w
        "
        sizes="(max-width: 500px) 100vw, 500px"
      />
      <figcaption>Mont Blanc appears—still, snowy, and serene.</figcaption>
    </figure>
  `);
                if (this.isIn((context.has(`alignment`) ? context.get(`alignment`) : null), new Map([[0, `alignleft`], [1, `aligncenter`], [2, `alignright`]]))) {
                    this.echo(`    </div>
  `);
                }
                this.echo(`  <p>Etiam porta sem malesuada magna mollis euismod. Maecenas sed diam eget risus varius blandit sit amet non magna. Nulla vitae elit libero, a pharetra augue. Aenean lacinia bibendum nulla sed consectetur. Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam.</p>
</div>
`);
            }

            getTemplateName() {
                return `02ab102cbe471eac0d8e51ed4cbcdf031f584277b74488bcbb884fa963acfdd5`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `02ab102cbe471eac0d8e51ed4cbcdf031f584277b74488bcbb884fa963acfdd5`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '02ab102cbe471eac0d8e51ed4cbcdf031f584277b74488bcbb884fa963acfdd5');

let template = env.loadTemplate('02ab102cbe471eac0d8e51ed4cbcdf031f584277b74488bcbb884fa963acfdd5');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/vendor/wordpress/demo/image.twig", args: context }
     );
     return rendered;;
};